import { render, staticRenderFns } from "./scroll-view.vue?vue&type=template&id=7218a4c9&scoped=true&"
import script from "./scroll-view.vue?vue&type=script&lang=tsx&"
export * from "./scroll-view.vue?vue&type=script&lang=tsx&"
import style0 from "./scroll-view.vue?vue&type=style&index=0&id=7218a4c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7218a4c9",
  null
  
)

export default component.exports